module.exports = __webpack_public_path__ + "assets/ceiba.849f3625.svg";